// CrossMall楽天受付ONかつ在庫0以下だけ予約。確認用カートは実カートと分離する。
(() => {
  'use strict';
  if (window.MBPreorder) return;
  const config = window.MB_PREORDER_CONFIG || {};
  const preview = window.Shopify?.theme?.role !== 'main';
  const simulation = preview && config.simulation === true;
  const storageKey = `mb-preorder-preview-${window.Shopify?.theme?.id || config.build}`;
  const root = window.Shopify?.routes?.root || '/';
  const reserveText = '予約商品は発送までに3〜4週間ほどお時間をいただきます。';
  const mixedDialog = document.getElementById('mb-mixed-dialog');
  const checkoutDialog = document.getElementById('mb-checkout-dialog');
  let simCartPage;
  let busy = false;
  let toastTimer;
  let pendingChoice;
  let modalBusy = false;
  let backdropTouchY = null;
  const money = value => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(value / 100);
  function stateOfVariant(variant) {
    if (!variant) return 'unknown';
    if (variant.tracked) {
      const quantity = Number(variant.quantity);
      if (!Number.isFinite(quantity)) return 'unknown';
      if (quantity <= 0) {
        if (variant.backorderAllowed === true) return 'preorder';
        if (variant.backorderAllowed === false) return 'soldout';
        return 'unknown';
      }
    }
    return variant.available === true ? 'instant' : 'soldout';
  }
  const isReserve = variant => stateOfVariant(variant) === 'preorder';
  const hasMixed = items => items.some(item => item.state === 'preorder') && items.some(item => item.state === 'instant');
  function classifyCartItem(item) {
    // Cart quantity is the ordered amount, while stock is the variant inventory.
    item.state = stateOfVariant({ ...item, quantity: item.stock });
    item.preorder = item.state === 'preorder';
    return item;
  }
  function unavailableMessage(item) {
    const name = `${item.title || '商品'}${item.variant_title && item.variant_title !== 'Default Title' ? ' ／ ' + item.variant_title : ''}`;
    return item.state === 'unknown'
      ? `${name}の予約受付設定を確認できません。カートから外してから購入手続きへ進んでください。`
      : `${name}は現在売り切れのため購入できません。カートから外してから購入手続きへ進んでください。`;
  }
  function validatePending(pending) {
    if (!pending || ['instant', 'preorder'].includes(pending.item.state)) return;
    throw new Error(pending.item.state === 'unknown' ? '予約受付設定を確認できません。この商品は現在カートに追加できません。' : 'このカラー・サイズは現在売り切れのためカートに追加できません。');
  }
  function validateCart(cart) {
    const blocked = cart.items.find(item => !['instant', 'preorder'].includes(item.state));
    if (blocked) throw new Error(unavailableMessage(blocked));
  }
  const originalDescriptions = new WeakMap();
  const $ = (selector, parent = document) => parent.querySelector(selector);
  const cartPaths = new Set(['/cart', `${root}cart`].map(path => path.replace(/\/$/, '')));
  function isCartUrl(url) {
    try {
      const target = new URL(url, location.origin);
      return target.origin === location.origin && cartPaths.has(target.pathname.replace(/\/$/, ''));
    } catch { return false; }
  }
  function cartTrigger(element) {
    const known = element?.closest('#cart-icon-bubble,#CartDrawer-ViewCart');
    if (known) return known;
    const link = element?.closest('a[href]');
    return link && isCartUrl(link.href) ? link : null;
  }
  const liveCartElement = element => element?.closest('cart-items,cart-drawer,cart-note,#main-cart-footer');
  const parse = (html, selector) => {
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!node) throw new Error('商品とカートの最新情報を確認できません。ページを読み直してください。');
    return JSON.parse(node.textContent);
  };
  function showStatus(message) {
    const status = $('#mb-preorder-status');
    status.textContent = message;
    status.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { status.hidden = true; }, 6500);
  }
  function closeDrawers() {
    document.querySelector('cart-drawer.active')?.close();
  }
  function savedCart() {
    try { return JSON.parse(sessionStorage.getItem(storageKey)) || []; } catch { return []; }
  }
  function saveCart(items) {
    sessionStorage.setItem(storageKey, JSON.stringify(items));
    document.querySelectorAll('[data-mb-count]').forEach(el => { el.textContent = items.reduce((n, item) => n + item.quantity, 0); });
  }
  async function section(url, name) {
    const target = new URL(url, location.origin);
    target.searchParams.set('sections', name);
    target.searchParams.set('mb_t', Date.now());
    const themeId = new URLSearchParams(location.search).get('preview_theme_id');
    if (themeId) target.searchParams.set('preview_theme_id', themeId);
    const res = await fetch(target, { cache: 'no-store', credentials: 'same-origin' });
    if (!res.ok) throw new Error('在庫の確認に失敗しました。少し待ってからもう一度お試しください。');
    const data = await res.json();
    if (!data[name]) throw new Error('テーマの確認に失敗しました。ページを読み直してください。');
    return data[name];
  }
  async function productInfo(url) {
    return parse(await section(url, 'mb-preorder-product'), '[data-mb-product-data]');
  }
  async function readCart() {
    if (!simulation) {
      const cart = parse(await section(root, 'mb-preorder-cart'), '[data-mb-cart-data]');
      cart.items.forEach(classifyCartItem);
      return cart;
    }
    const items = savedCart();
    const handles = [...new Set(items.map(item => item.handle))];
    const products = await Promise.all(handles.map(handle => productInfo(`${root}products/${encodeURIComponent(handle)}`)));
    for (const item of items) {
      const variant = products.find(p => p.handle === item.handle)?.variants.find(v => String(v.id) === String(item.id));
      if (!variant) throw new Error('カート内の商品を確認できません。確認用カートを空にしてください。');
      item.stock = variant.quantity;
      item.tracked = variant.tracked;
      item.policy = variant.policy;
      item.sku = variant.sku;
      item.available = variant.available;
      item.backorderAllowed = variant.backorderAllowed;
      classifyCartItem(item);
    }
    saveCart(items);
    return { items, item_count: items.reduce((n, item) => n + item.quantity, 0), total_price: items.reduce((n, item) => n + item.price * item.quantity, 0) };
  }
  function localProduct(form) {
    const component = form.closest('product-form');
    const script = $('[data-mb-product-data]', component || form.parentElement);
    if (script) return JSON.parse(script.textContent);
    return null;
  }
  async function pendingItem(form) {
    const data = new FormData(form);
    const id = data.get('id');
    if (!id) throw new Error('カラー・サイズを選択してください。');
    const count = Number(data.get('quantity') || 1);
    if (!Number.isInteger(count) || count < 1) throw new Error('数量は1以上の整数で入力してください。');
    const local = localProduct(form);
    const link = form.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
    const url = local?.url || link?.getAttribute('href');
    if (!url) throw new Error('商品ページでカラー・サイズを選択してから追加してください。');
    // 商品ページではすでにSKU別データを埋め込んでいるため、まずそれを使う。
    // 追加直前のrefreshPendingで最新在庫を取り直すので、ここでの通信は不要。
    let product = local;
    let variant = product?.variants.find(v => String(v.id) === String(id));
    if (!product || !variant) {
      product = await productInfo(url);
      variant = product.variants.find(v => String(v.id) === String(id));
    }
    if (!variant) throw new Error('選択された商品を確認できません。もう一度選択してください。');
    return { form, data, product, variant, item: classifyCartItem({ id: variant.id, key: String(variant.id), handle: product.handle, title: product.title, variant_title: variant.title, image: variant.image, quantity: count, price: variant.price, tracked: variant.tracked, stock: variant.quantity, policy: variant.policy, sku: variant.sku, available: variant.available, backorderAllowed: variant.backorderAllowed }) };
  }
  function validateQuantity(cart, pending) {
    if (!pending || pending.item.state !== 'instant' || !pending.item.tracked) return;
    const existing = cart.items.filter(item => String(item.id) === String(pending.item.id)).reduce((n, item) => n + item.quantity, 0);
    if (existing + pending.item.quantity > pending.item.stock) throw new Error(`このカラー・サイズの即納在庫は${pending.item.stock}点です。カート内の数量も含めて調整してください。`);
  }
  async function refreshPending(pending) {
    if (!pending) return;
    const product = await productInfo(pending.product.url);
    const variant = product.variants.find(item => String(item.id) === String(pending.item.id));
    if (!variant) throw new Error('選択された商品を確認できません。もう一度選択してください。');
    pending.product = product;
    pending.variant = variant;
    Object.assign(pending.item, { stock: variant.quantity, tracked: variant.tracked, policy: variant.policy, price: variant.price, sku: variant.sku, image: variant.image, available: variant.available, backorderAllowed: variant.backorderAllowed });
    classifyCartItem(pending.item);
  }
  function selectChoice(cart) {
    renderMixedCart(cart);
    $('[data-mb-modal-error]', mixedDialog).hidden = true;
    mixedDialog.showModal();
    // 最初は即納を残す選択肢にフォーカスし、Enterだけで納期への同意にならないようにする。
    $('[data-mb-choice="instant"]', mixedDialog).focus();
    return new Promise(resolve => { pendingChoice = resolve; });
  }
  // On mobile, a vertical swipe that starts in the narrow backdrop beside the
  // centered dialog otherwise scrolls the page behind it. Route that gesture
  // to the dialog itself so the confirmation remains usable from either side.
  document.addEventListener('touchstart', event => {
    backdropTouchY = null;
    if (!mixedDialog?.open || event.touches.length !== 1) return;
    const touch = event.touches[0];
    const rect = mixedDialog.getBoundingClientRect();
    if (touch.clientX < rect.left || touch.clientX > rect.right || touch.clientY < rect.top || touch.clientY > rect.bottom) {
      backdropTouchY = touch.clientY;
    }
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', event => {
    if (backdropTouchY === null || !mixedDialog?.open || event.touches.length !== 1) return;
    const touch = event.touches[0];
    mixedDialog.scrollTop += backdropTouchY - touch.clientY;
    backdropTouchY = touch.clientY;
    event.preventDefault();
  }, { capture: true, passive: false });
  const clearBackdropTouch = () => { backdropTouchY = null; };
  document.addEventListener('touchend', clearBackdropTouch, { capture: true, passive: true });
  document.addEventListener('touchcancel', clearBackdropTouch, { capture: true, passive: true });
  function resolveChoice(choice) {
    if (!pendingChoice) return;
    const resolve = pendingChoice;
    pendingChoice = null;
    mixedDialog.close();
    resolve(choice);
  }
  function updateSimQuantity(item, nextQuantity) {
    const quantity = Number(nextQuantity);
    if (!Number.isInteger(quantity) || quantity < 1) {
      showStatus('数量は1以上で入力してください。');
      renderSimCartPage().catch(error => showStatus(error.message));
      return;
    }
    if (item.state === 'instant' && item.tracked && quantity > item.stock) {
      showStatus(`この商品の即納在庫は${item.stock}点です。`);
      renderSimCartPage().catch(error => showStatus(error.message));
      return;
    }
    const items = savedCart();
    const current = items.find(line => line.key === item.key);
    if (!current) return;
    current.quantity = quantity;
    saveCart(items);
    renderSimCartPage().catch(error => showStatus(error.message));
  }
  function removeSimItem(item) {
    if (busy) return;
    saveCart(savedCart().filter(current => current.key !== item.key));
    renderSimCartPage().catch(error => showStatus(error.message));
  }
  async function updateMixedCartLine(item, nextQuantity, remove = false) {
    if (modalBusy) return;
    const quantity = remove ? 0 : Number(nextQuantity);
    if (!remove && (!Number.isInteger(quantity) || quantity < 1)) {
      showStatus('数量は1以上で入力してください。');
      return;
    }
    if (quantity > 0 && item.state === 'instant' && item.tracked && quantity > item.stock) {
      showStatus(`この商品の即納在庫は${item.stock}点です。`);
      return;
    }
    modalBusy = true;
    mixedDialog.querySelectorAll('[data-mb-cart-control]').forEach(control => { control.disabled = true; });
    try {
      if (simulation) {
        let items = savedCart();
        if (quantity === 0) items = items.filter(line => line.key !== item.key);
        else {
          const current = items.find(line => line.key === item.key);
          if (!current) return;
          current.quantity = quantity;
        }
        saveCart(items);
      } else {
        const res = await fetch(`${root}cart/change.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ id: item.key, quantity, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname + location.search }),
        });
        const payload = await res.json();
        if (!res.ok || payload.status) throw new Error(payload.description || 'カートの商品を更新できませんでした。');
        await refreshLiveCart(payload);
      }
      const cart = await readCart();
      renderMixedCart(cart);
      if (!cart.items.some(line => line.preorder)) resolveChoice('instant');
    } catch (error) {
      showStatus(error.message || 'カートの商品を更新できませんでした。');
      const cart = await readCart().catch(() => null);
      if (cart) renderMixedCart(cart);
    } finally {
      modalBusy = false;
      mixedDialog.querySelectorAll('[data-mb-cart-control]').forEach(control => { control.disabled = false; });
    }
  }
  function renderMixedCart(cart) {
    const target = $('[data-mb-mixed-cart-lines]', mixedDialog);
    lineList(target, cart, {
      update: (item, quantity) => updateMixedCartLine(item, quantity),
      remove: item => updateMixedCartLine(item, 0, true),
    });
    renderFreeShipping($('[data-mb-mixed-free-shipping]', mixedDialog), cart);
    $('[data-mb-mixed-cart-total]', mixedDialog).textContent = money(cart.total_price);
    $('[data-mb-choice="instant"]', mixedDialog).disabled = !cart.items.some(item => item.state === 'instant');
  }
  function lineList(target, cart, actions) {
    target.replaceChildren();
    if (!cart.items.length) { target.textContent = 'カートに商品がありません。'; return; }
    for (const item of cart.items) {
      const line = document.createElement('div');
      line.className = 'mb-cart-line';
      const product = document.createElement('div');
      product.className = 'mb-cart-product';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        product.append(image);
      }
      const content = document.createElement('div');
      content.className = 'mb-cart-product-details';
      const title = document.createElement('strong');
      title.textContent = item.title;
      content.append(title, document.createElement('br'));
      const detail = document.createElement('span');
      detail.textContent = `${item.variant_title === 'Default Title' ? '' : item.variant_title + ' ／ '}${item.quantity}点`;
      content.append(detail);
      product.append(content);
      line.append(product);
      const price = document.createElement('strong');
      price.className = 'mb-cart-line-price';
      price.textContent = money(item.price * item.quantity);
      line.append(price);
      if (item.preorder) {
        line.classList.add('mb-cart-line-preorder');
        const note = document.createElement('div');
        note.className = 'mb-cart-reserve-label';
        note.textContent = '予約商品・発送まで3〜4週間';
        line.append(note);
      } else if (item.state === 'instant') {
        const note = document.createElement('div');
        note.className = 'mb-cart-reserve-label';
        note.textContent = '即納商品・1〜3営業日以内に発送';
        line.append(note);
      } else if (item.state === 'soldout' || item.state === 'unknown') {
        const note = document.createElement('div');
        note.className = 'mb-cart-reserve-label';
        note.textContent = item.state === 'unknown' ? '予約受付設定を確認できないため、現在購入できません。' : '現在売り切れのため購入できません。';
        line.append(note);
      }
      if (actions) {
        const controls = document.createElement('div');
        controls.className = 'mb-sim-quantity';
        const decrement = document.createElement('button');
        decrement.type = 'button';
        decrement.textContent = '−';
        decrement.setAttribute('aria-label', `${item.title}の数量を減らす`);
        decrement.dataset.mbCartControl = '';
        decrement.disabled = item.quantity <= 1;
        decrement.addEventListener('click', () => actions.update(item, item.quantity - 1));
        const quantity = document.createElement('input');
        quantity.type = 'number';
        quantity.min = '1';
        if (item.state === 'instant' && item.tracked) quantity.max = String(item.stock);
        quantity.value = String(item.quantity);
        quantity.setAttribute('aria-label', `${item.title}の数量`);
        quantity.dataset.mbCartControl = '';
        quantity.addEventListener('change', () => actions.update(item, quantity.value));
        const increment = document.createElement('button');
        increment.type = 'button';
        increment.textContent = '＋';
        increment.setAttribute('aria-label', `${item.title}の数量を増やす`);
        increment.dataset.mbCartControl = '';
        increment.disabled = item.state === 'instant' && item.tracked && item.quantity >= item.stock;
        increment.addEventListener('click', () => actions.update(item, item.quantity + 1));
        controls.append(decrement, quantity, increment);
        line.append(controls);
        const remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = '削除';
        remove.dataset.mbCartControl = '';
        remove.addEventListener('click', () => actions.remove(item));
        line.append(remove);
      }
      target.append(line);
    }
  }
  function renderFreeShipping(target, cart) {
    const shipping = config.freeShipping || {};
    target.replaceChildren();
    target.hidden = !shipping.enabled || !cart.items.length;
    if (target.hidden) return;
    const remaining = Math.max(0, Number(shipping.threshold) * (Number(window.Shopify?.currency?.rate) || 1) * 100 - cart.total_price);
    if (remaining > 0) {
      const amount = document.createElement('strong');
      amount.textContent = money(remaining);
      target.append(document.createTextNode(shipping.before || 'あと'), amount, document.createTextNode(shipping.after || 'で送料無料です'));
    } else {
      target.textContent = shipping.success || '送料無料の対象です';
    }
  }
  async function renderSimCartPage() {
    if (!simCartPage) return;
    const cart = await readCart();
    $('[data-mb-sim-preorder-notice]', simCartPage).hidden = !cart.items.some(item => item.state === 'preorder');
    lineList($('[data-mb-sim-cart-lines]', simCartPage), cart, {
      update: (item, quantity) => updateSimQuantity(item, quantity),
      remove: item => removeSimItem(item),
    });
    renderFreeShipping($('[data-mb-sim-free-shipping]', simCartPage), cart);
    $('[data-mb-sim-cart-total]', simCartPage).textContent = money(cart.total_price);
    $('.mb-sim-tax-note', simCartPage).hidden = !cart.items.length;
    const mixedNote = $('[data-mb-sim-mixed-note]', simCartPage);
    mixedNote.hidden = !hasMixed(cart.items);
    $('[data-mb-sim-checkout]', simCartPage).textContent = cart.items.some(item => item.state === 'preorder') ? 'すべて購入手続きへ進む' : '購入手続きへ進む';
    $('[data-mb-sim-checkout]', simCartPage).disabled = !cart.items.length || cart.items.some(item => !['instant', 'preorder'].includes(item.state));
    $('[data-mb-checkout-instant]', simCartPage).disabled = !cart.items.some(item => item.state === 'instant');
  }
  function navigateToCart() {
    if (!isCartUrl(location.href)) location.assign(`${root}cart`);
  }
  function revealLiveCartItems(drawer) {
    // Cart drawer content is inserted while the drawer is closed. Its AOS
    // wrapper can then remain at opacity: 0 because it never enters the page's
    // scroll viewport (on both desktop and mobile). Cart rows must be visible
    // immediately inside the drawer, so remove the scroll animation from the
    // dynamically rendered cart area.
    drawer?.querySelectorAll('#CartDrawer-CartItems[data-aos], #CartDrawer-CartItems [data-aos]').forEach(element => {
      element.removeAttribute('data-aos');
      element.classList.remove('aos-init', 'aos-animate');
      element.style.removeProperty('opacity');
      element.style.removeProperty('transform');
      element.style.removeProperty('visibility');
    });
  }
  async function refreshLiveCart(payload) {
    const drawer = document.querySelector('cart-drawer');
    if (payload?.sections?.['cart-drawer'] && typeof drawer?.renderContents === 'function') {
      drawer.renderContents(payload);
      drawer.classList.remove('is-empty');
      revealLiveCartItems(drawer);
    } else {
      const bubble = payload?.sections?.['cart-icon-bubble'];
      if (bubble) {
        const source = new DOMParser().parseFromString(bubble, 'text/html').querySelector('#cart-icon-bubble');
        const target = $('#cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }
    }
    // その他のテーマ要素は標準どおりAOSへ再登録する。
    if (typeof AOS !== 'undefined') AOS.init();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mb-preorder' });
  }
  async function add(pending) {
    if (!pending) return;
    validatePending(pending);
    if (simulation) {
      const items = savedCart();
      const existing = items.find(item => String(item.id) === String(pending.item.id) && item.preorder === pending.item.preorder);
      if (existing) existing.quantity += pending.item.quantity;
      else items.push({ ...pending.item, key: `${pending.item.id}-${pending.item.preorder ? 'reserve' : 'instant'}` });
      saveCart(items);
      return;
    }
    if (pending.item.preorder && pending.variant.policy !== 'continue') throw new Error('この商品は現在、Shopifyの商品設定で在庫切れ販売が停止されています。予約操作はもう一方の確認用テーマでお試しください。');
    if (pending.item.preorder) {
      pending.data.set('properties[予約商品]', '発送までに3〜4週間ほどお時間をいただきます');
      pending.data.set('properties[_mb_preorder]', 'true');
    }
    pending.data.set('sections', 'cart-drawer,cart-icon-bubble');
    pending.data.set('sections_url', location.pathname + location.search);
    const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: pending.data, credentials: 'same-origin' });
    const payload = await res.json();
    if (!res.ok || payload.status) {
      // 422でも一部が追加されている場合があるため必ず最新表示を取得する。
      await refreshLiveCart();
      throw new Error(payload.description || '商品を追加できませんでした。カートの内容をご確認ください。');
    }
    await refreshLiveCart(payload);
  }
  async function retainInstants() {
    if (simulation) { const cart = await readCart(); saveCart(cart.items.filter(item => item.state === 'instant')); return; }
    for (let count = 0; count < 100; count++) {
      const cart = await readCart();
      const item = cart.items.find(line => line.state !== 'instant');
      if (!item) return;
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ id: item.key, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname + location.search }),
      });
      const payload = await res.json();
      if (!res.ok || payload.status) throw new Error('即納以外の商品を外せませんでした。カートの内容をご確認ください。');
      await refreshLiveCart(payload);
    }
    throw new Error('カートの商品が多いため、一度内容を確認してから再度お試しください。');
  }
  async function checkout() {
    const cart = await readCart();
    if (!cart.items.length) { showStatus('カートに商品がありません。'); return; }
    validateCart(cart);
    closeDrawers();
    if (preview && simulation) {
      lineList($('[data-mb-checkout-lines]'), cart, false);
      $('[data-mb-checkout-total]').textContent = `小計 ${money(cart.total_price)}`;
      checkoutDialog.showModal();
    } else location.assign(`${root}checkout`);
  }
  async function run(pending, toCheckout = false, instantOnly = false) {
    if (busy) return;
    busy = true;
    const button = pending?.form?.querySelector('[name="add"]');
    button?.setAttribute('aria-disabled', 'true');
    try {
      let cart;
      if (pending) {
        // カートの読み取りとSKU在庫の再確認は独立しているので並行実行する。
        [cart] = await Promise.all([readCart(), refreshPending(pending)]);
        validatePending(pending);
        validateQuantity(cart, pending);
      } else {
        cart = await readCart();
      }
      if (toCheckout && !instantOnly) validateCart(cart);
      if (instantOnly) {
        if (!cart.items.some(item => item.state === 'instant')) { showStatus('即納商品がカートにありません。'); return; }
        await retainInstants();
        await checkout();
        return;
      }
      let choice = null;
      if (pending) {
        await add(pending);
        cart = await readCart();
        if (hasMixed(cart.items)) {
          choice = await selectChoice(cart);
          if (choice === 'cancel') return;
        }
      } else if (toCheckout && hasMixed(cart.items)) {
        choice = await selectChoice(cart);
        if (choice === 'cancel') return;
      }
      if (choice === 'instant') {
        await retainInstants();
        if (simulation) navigateToCart();
      }
      else if (choice === 'all' || toCheckout) await checkout();
      else if (simulation && pending) navigateToCart();
    } catch (error) {
      showStatus(error.message || '処理に失敗しました。もう一度お試しください。');
    } finally {
      busy = false;
      button?.removeAttribute('aria-disabled');
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const addForm = form.action.includes('/cart/add');
    const checkoutForm = event.submitter?.name === 'checkout';
    if (simulation && !addForm && (liveCartElement(form) || isCartUrl(form.action))) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!busy) renderSimCartPage().catch(error => showStatus(error.message));
      return;
    }
    if (!addForm && !checkoutForm) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    if (!addForm) { run(null, true); return; }
    // 追加候補の確認中も連打を止める。取得前にFormDataを固定し、後の選択変更を混ぜない。
    busy = true;
    pendingItem(form).then(pending => { busy = false; run(pending); }).catch(error => { busy = false; showStatus(error.message); });
  }, true);
  document.addEventListener('click', event => {
    const element = event.target instanceof Element ? event.target : event.target?.parentElement;
    const instantCheckoutButton = element?.closest('[data-mb-checkout-instant]');
    if (instantCheckoutButton) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!busy) run(null, true, true);
      return;
    }
    if (simulation && (cartTrigger(element) || liveCartElement(element))) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!busy && cartTrigger(element)) navigateToCart();
      return;
    }
    if (!simulation && cartTrigger(element)) {
      event.preventDefault(); event.stopImmediatePropagation();
      navigateToCart();
      return;
    }
    const checkoutButton = element?.closest('button[name="checkout"],a[href="/checkout"],a[href$="/checkout"]');
    if (checkoutButton) {
      if (checkoutButton.disabled) return;
      event.preventDefault(); event.stopImmediatePropagation(); run(null, true); return;
    }
  }, true);
  if (simulation) {
    // The theme opens the real drawer directly on Space. Capture it before the
    // existing listener, and stop real quantity/note changes on every page.
    document.addEventListener('keydown', event => {
      if (![' ', 'Spacebar', 'Enter'].includes(event.key) || !cartTrigger(event.target)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!busy) navigateToCart();
    }, true);
    for (const type of ['input', 'change']) document.addEventListener(type, event => {
      if (!liveCartElement(event.target)) return;
      event.preventDefault(); event.stopImmediatePropagation();
    }, true);
    document.querySelectorAll('cart-drawer,cart-items,#main-cart-footer').forEach(element => {
      const container = element.tagName === 'CART-DRAWER' ? element : element.closest('.shopify-section') || element;
      container.hidden = true;
      container.inert = true;
      container.setAttribute('aria-hidden', 'true');
      container.style.setProperty('display', 'none', 'important');
    });
    if (isCartUrl(location.href)) {
      simCartPage = document.createElement('section');
      simCartPage.id = 'mb-sim-cart-page';
      simCartPage.className = 'page-width';
      simCartPage.innerHTML = '<h1>カート</h1><p data-mb-sim-preorder-notice class="mb-cart-preorder-notice" role="status" hidden>予約商品が含まれています</p><p>動作確認用カートです。実際のカート・注文には反映されません。</p><div class="mb-sim-free-shipping" data-mb-sim-free-shipping hidden></div><div data-mb-sim-cart-lines></div><div class="mb-sim-cart-summary"><span>小計</span><strong data-mb-sim-cart-total></strong></div><p class="mb-sim-tax-note">税金は含まれています。送料はチェックアウト時に計算されます。</p><div data-mb-sim-mixed-note hidden><p>※即納商品と予約商品を一緒にご購入の場合は、予約商品に合わせてまとめて発送します。予約商品は発送までに3〜4週間ほどお時間をいただきます。</p><button type="button" class="mb-button mb-button-primary" data-mb-checkout-instant>即納商品のみで購入手続きへ進む</button></div><button type="button" class="mb-button mb-button-primary" data-mb-sim-checkout>購入手続きへ進む</button><p><a class="link" href="' + `${root}collections/all` + '">商品一覧へ戻る</a></p>';
      (document.querySelector('main') || document.body).prepend(simCartPage);
      $('[data-mb-sim-checkout]', simCartPage).addEventListener('click', () => run(null, true));
      renderSimCartPage().catch(error => showStatus(error.message));
    }
  }
  mixedDialog.addEventListener('cancel', event => { event.preventDefault(); resolveChoice('cancel'); });
  mixedDialog.addEventListener('click', event => {
    const choice = event.target.closest('[data-mb-choice]')?.dataset.mbChoice;
    if (choice) resolveChoice(choice);
    else if (event.target.closest('[data-mb-cancel]')) resolveChoice('cancel');
  });
  document.querySelectorAll('[data-mb-close-checkout]').forEach(button => button.addEventListener('click', () => checkoutDialog.close()));
  $('[data-mb-open-cart]').addEventListener('click', () => {
    navigateToCart();
  });
  $('[data-mb-reset-cart]').addEventListener('click', () => { if (!busy && simulation) { saveCart([]); if (isCartUrl(location.href)) renderSimCartPage().catch(error => showStatus(error.message)); } });
  function updateDescription(form, variant) {
    const description = form?.closest('[id^="MainProduct-"]')?.querySelector('.product-description');
    if (!description) return;
    // 本文の即納表記も選択に合わせる。商品説明の残りと管理画面の商品データは変更しない。
    if (!originalDescriptions.has(description)) originalDescriptions.set(description, description.innerHTML);
    description.innerHTML = originalDescriptions.get(description);
    if (!isReserve(variant || {})) return;
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      walker.currentNode.textContent = walker.currentNode.textContent.replace(/1[～〜~－-]3営業日以内に発送/g, '予約商品は発送までに3〜4週間ほどお時間をいただきます');
    }
  }
  document.addEventListener('mb:variant-change', event => updateDescription(event.detail.form, event.detail.variant));
  document.querySelectorAll('product-form[data-mb-product] form').forEach(form => {
    const product = localProduct(form);
    const variantId = form.querySelector('[name="id"]')?.value;
    updateDescription(form, product?.variants.find(variant => String(variant.id) === variantId));
  });
  if (preview) {
    document.body.prepend($('#mb-preview-banner'));
    $('#mb-preview-banner').hidden = false;
    if (config.snapshot?.checkedAt) {
      const checkedAt = new Date(config.snapshot.checkedAt);
      const date = new Intl.DateTimeFormat('ja-JP', { timeZone: 'Asia/Tokyo', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(checkedAt);
      const scope = config.snapshot.productCount
        ? `公開中${config.snapshot.productCount}商品・${Number(config.snapshot.variantCount || 0).toLocaleString('ja-JP')} SKU`
        : `確認対象：${(config.snapshot.handles || []).join('・')}`;
      const unknown = Number(config.snapshot.variantsWithoutRmsSku || 0);
      $('.mb-snapshot-note').textContent = `楽天受付設定：${date}最終反映 ／ ${scope}${unknown ? `（楽天SKU未照合 ${unknown}件）` : ''}`;
    }
    $('[data-mb-preview-label]').textContent = simulation ? '非公開テーマ／動作確認用カート（実際の注文は行われません）' : '非公開テーマ／通常カートの確認（購入手続きに進みます。注文確定はしないでください）';
    $('[data-mb-open-cart]').firstChild.textContent = 'カートを見る ';
    $('[data-mb-reset-cart]').hidden = !simulation;
    $('[data-mb-count]').hidden = !simulation;
    if (simulation) saveCart(savedCart());
    const banner = $('#mb-preview-banner');
    const updateBannerHeight = () => document.body.style.setProperty('--mb-preview-banner-height', `${Math.ceil(banner.getBoundingClientRect().height)}px`);
    updateBannerHeight();
    new ResizeObserver(updateBannerHeight).observe(banner);
  }
  window.MBPreorder = { simulation, preview, reserveText, stateOfVariant };
})();
